import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Upload, Loader2, Eye, Star, HelpCircle, Plus, Trash2, Mail } from 'lucide-react';

export const SettingsBrandTab = ({
  settings, setSettings, profile, setProfile,
  company, saving, savingProfile,
  handleSave, handleSaveProfile, handleLogoUpload
}) => (
  <div className="space-y-6">
    {/* Dados da Empresa */}
    <Card className="card-premium border-[#0A2647]/20">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Dados da Empresa</CardTitle>
        <CardDescription>Edite o nome da empresa, seu nome e e-mail</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <Label className="text-sm font-medium mb-1.5 block">Nome da Empresa</Label>
            <Input value={profile.company_name} onChange={(e) => setProfile(prev => ({ ...prev, company_name: e.target.value }))} className="h-11" placeholder="Nome da sua empresa" data-testid="profile-company-name" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Label className="text-sm font-medium mb-1.5 block">Seu Nome</Label>
              <Input value={profile.owner_name} onChange={(e) => setProfile(prev => ({ ...prev, owner_name: e.target.value }))} className="h-11" placeholder="Seu nome completo" data-testid="profile-owner-name" />
            </div>
            <div>
              <Label className="text-sm font-medium mb-1.5 block">E-mail</Label>
              <Input type="email" value={profile.owner_email} onChange={(e) => setProfile(prev => ({ ...prev, owner_email: e.target.value }))} className="h-11" placeholder="seu@email.com" data-testid="profile-owner-email" />
            </div>
          </div>
          <Button onClick={handleSaveProfile} disabled={savingProfile} className="btn-primary h-10" data-testid="profile-save-btn">
            {savingProfile ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Salvando...</> : 'Salvar Dados'}
          </Button>
        </div>
      </CardContent>
    </Card>

    {/* Colors - ANTES da logo para o color picker não sobrepor */}
    <Card className="card-premium">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Cores da Marca</CardTitle>
        <CardDescription>Essas cores serao aplicadas na pagina de avaliação</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-6">
          <div className="space-y-3">
            <Label className="text-sm font-medium">Cor Principal</Label>
            <div className="flex items-center gap-3">
              <Input value={settings.primary_color} onChange={(e) => setSettings(prev => ({ ...prev, primary_color: e.target.value }))} className="flex-1 h-10 font-mono text-sm uppercase" data-testid="primary-color-input" />
              <input type="color" value={settings.primary_color} onChange={(e) => setSettings(prev => ({ ...prev, primary_color: e.target.value }))} className="w-14 h-14 rounded-xl cursor-pointer border-2 border-slate-200" data-testid="primary-color-picker" />
            </div>
            <p className="text-xs text-slate-500">Usada no cabecalho e botoes</p>
          </div>
          <div className="space-y-3">
            <Label className="text-sm font-medium">Cor Secundaria</Label>
            <div className="flex items-center gap-3">
              <Input value={settings.secondary_color} onChange={(e) => setSettings(prev => ({ ...prev, secondary_color: e.target.value }))} className="flex-1 h-10 font-mono text-sm uppercase" data-testid="secondary-color-input" />
              <input type="color" value={settings.secondary_color} onChange={(e) => setSettings(prev => ({ ...prev, secondary_color: e.target.value }))} className="w-14 h-14 rounded-xl cursor-pointer border-2 border-slate-200" data-testid="secondary-color-picker" />
            </div>
            <p className="text-xs text-slate-500">Usada nas estrelas e destaques</p>
          </div>
        </div>
        <div className="mt-6 p-4 rounded-xl border border-slate-200 bg-slate-50">
          <p className="text-xs font-medium text-slate-500 mb-3">PRE-VISUALIZACAO</p>
          <div className="flex items-center gap-3">
            <div className="h-10 px-4 rounded-lg flex items-center text-white text-sm font-medium" style={{ backgroundColor: settings.primary_color }}>Botao Principal</div>
            <div className="flex gap-1">
              {[1,2,3,4,5].map(i => <Star key={`star-${i}`} className="w-6 h-6" style={{ fill: settings.secondary_color, color: settings.secondary_color }} />)}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>

    {/* Logo Upload */}
    <Card className="card-premium">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Logo da Empresa</CardTitle>
        <CardDescription>Sua logo aparecera na pagina de avaliação</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-5">
          <div className="w-24 h-24 rounded-2xl flex items-center justify-center overflow-hidden border-2 border-dashed" style={{ backgroundColor: settings.logo_url ? 'white' : settings.primary_color + '10', borderColor: settings.primary_color + '40' }}>
            {settings.logo_url ? <img src={`${process.env.REACT_APP_BACKEND_URL}${settings.logo_url}`} alt="Logo" className="max-w-full max-h-full object-contain" /> : <Upload className="w-8 h-8" style={{ color: settings.primary_color }} />}
          </div>
          <div>
            <Label htmlFor="logo" className="cursor-pointer">
              <div className="btn-outline inline-flex items-center gap-2 cursor-pointer"><Upload className="w-4 h-4" />Enviar Logo</div>
            </Label>
            <input id="logo" type="file" accept="image/*" onChange={handleLogoUpload} className="hidden" />
            <p className="text-xs text-slate-500 mt-2">PNG ou JPG, recomendado 200x200px</p>
          </div>
        </div>
      </CardContent>
    </Card>

    {/* Quem responde os clientes? */}
    <Card className="card-premium border-[#C5A059]/30" data-testid="owner-title-card">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Quem responde os clientes?</CardTitle>
        <CardDescription>As placas e materiais de impressão se adaptam automaticamente (ex: "FALE COM A DONA!")</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {[
            { id: 'dono', label: 'O Dono', sample: '"Fale direto com o Dono"' },
            { id: 'dona', label: 'A Dona', sample: '"Fale direto com a Dona"' },
            { id: 'neutro', label: 'Neutro', sample: '"Fale com quem manda"' },
          ].map(opt => (
            <button
              key={opt.id}
              type="button"
              onClick={() => setSettings(prev => ({ ...prev, owner_title: opt.id }))}
              data-testid={`owner-title-${opt.id}`}
              className={`p-3 rounded-xl border-2 text-left transition-all ${(settings.owner_title || 'dono') === opt.id ? 'border-[#C5A059] bg-[#C5A059]/10' : 'border-slate-200 hover:border-slate-300'}`}
            >
              <p className={`text-sm font-bold ${(settings.owner_title || 'dono') === opt.id ? 'text-[#0A2647]' : 'text-slate-700'}`}>{opt.label}</p>
              <p className="text-[11px] text-slate-500 mt-0.5">{opt.sample}</p>
            </button>
          ))}
        </div>
        <p className="text-[11px] text-slate-400 mt-3">Após salvar, baixe novamente suas placas na aba QR Code — elas já sairão com o novo texto.</p>
      </CardContent>
    </Card>

    {/* Thank You Message */}
    <Card className="card-premium">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Mensagem de Agradecimento</CardTitle>
        <CardDescription>Exibida após o cliente enviar a avaliação</CardDescription>
      </CardHeader>
      <CardContent>
        <Textarea value={settings.thank_you_message} onChange={(e) => setSettings(prev => ({ ...prev, thank_you_message: e.target.value }))} rows={3} className="resize-none" placeholder="Obrigado pela sua avaliação!" />
      </CardContent>
    </Card>

    {/* Contact Info */}
    <Card className="card-premium border-blue-200/50 bg-blue-50/30">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Dados de Contato</CardTitle>
        <CardDescription>Informe seus e-mails e WhatsApp para receber alertas</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-3">
            <Label className="text-sm font-medium mb-1.5 block flex items-center gap-2"><Mail className="w-4 h-4 text-blue-500" />E-mails para Receber Alertas</Label>
            <Input type="email" value={settings.contact_email || ''} onChange={(e) => setSettings(prev => ({ ...prev, contact_email: e.target.value }))} placeholder="contato@suaempresa.com (principal)" className="h-11" data-testid="contact-email-input" />
            {(settings.notification_emails || []).map((email, idx) => (
              <div key={`notif-email-${email || idx}`} className="flex items-center gap-2">
                <Input type="email" value={email} onChange={(e) => { const updated = [...(settings.notification_emails || [])]; updated[idx] = e.target.value; setSettings(prev => ({ ...prev, notification_emails: updated })); }} placeholder={`E-mail adicional ${idx + 2}`} className="h-11 flex-1" data-testid={`notification-email-input-${idx}`} />
                <Button type="button" variant="ghost" size="icon" onClick={() => { const updated = (settings.notification_emails || []).filter((_, i) => i !== idx); setSettings(prev => ({ ...prev, notification_emails: updated })); }} className="h-11 w-11 text-red-500 hover:text-red-700 hover:bg-red-50 shrink-0" data-testid={`remove-notification-email-${idx}`}><Trash2 className="w-4 h-4" /></Button>
              </div>
            ))}
            <Button type="button" variant="outline" size="sm" onClick={() => setSettings(prev => ({ ...prev, notification_emails: [...(prev.notification_emails || []), ''] }))} className="text-xs gap-1.5 text-blue-600 border-blue-200 hover:bg-blue-50" data-testid="add-notification-email-btn"><Plus className="w-3.5 h-3.5" />Adicionar outro e-mail</Button>
            <p className="text-xs text-slate-500">Todos os e-mails cadastrados receberao alertas simultaneamente.</p>
          </div>
          <div className="space-y-3">
            <Label className="text-sm font-medium mb-1.5 block">WhatsApp para Receber Alertas</Label>
            <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg space-y-2">
              <div className="flex items-start gap-2"><span className="text-emerald-600 text-lg leading-none mt-0.5">1.</span><p className="text-xs text-emerald-800"><strong>Formato obrigatório:</strong> 55 + DDD + número (13 digitos)<br/><span className="text-emerald-600">Exemplo: <code className="bg-white/70 px-1.5 py-0.5 rounded font-mono text-xs">5531991316297</code></span></p></div>
              <div className="flex items-start gap-2"><span className="text-emerald-600 text-lg leading-none mt-0.5">2.</span><p className="text-xs text-emerald-800"><strong>Multiplos números?</strong> Separe por virgula:<br/><span className="text-emerald-600">Exemplo: <code className="bg-white/70 px-1.5 py-0.5 rounded font-mono text-xs">5531991316297, 5531988887777</code></span></p></div>
            </div>
            <Input type="text" value={settings.contact_whatsapp || ''} onChange={(e) => { const cleaned = e.target.value.replace(/[^0-9,\s]/g, ''); setSettings(prev => ({ ...prev, contact_whatsapp: cleaned })); }} placeholder="5531991316297, 5531988887777" className="h-12 text-base font-mono pl-4 pr-4" data-testid="contact-whatsapp-input" />
            {(() => {
              const limits = { free: 1, pro: 2, enterprise: 3, elite: 4, five_stars: null };
              const planNames = { free: 'Free', pro: 'Pro', enterprise: 'Empresarial', elite: 'Elite', five_stars: '5 Estrelas' };
              const plan = company?.plan || 'free';
              const limit = limits[plan];
              const currentNumbers = (settings.contact_whatsapp || '').split(',').filter(n => n.trim()).length;
              const hasContent = (settings.contact_whatsapp || '').trim().length > 0;
              return (
                <div className="space-y-1.5">
                  <div className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium ${limit === null ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-amber-50 text-amber-700 border border-amber-200'}`}>
                    <span>{limit === null ? 'Números ilimitados' : `Plano ${planNames[plan]}: ate ${limit} número(s)`}</span>
                    {hasContent && limit !== null && <span className={`ml-auto font-bold ${currentNumbers > limit ? 'text-red-600' : 'text-emerald-600'}`}>{currentNumbers}/{limit} usado(s)</span>}
                  </div>
                  {limit !== null && hasContent && currentNumbers > limit && <p className="text-xs text-red-600 font-semibold px-1">Limite excedido! Remova {currentNumbers - limit} número(s) ou faca upgrade do plano.</p>}
                </div>
              );
            })()}
          </div>
        </div>
      </CardContent>
    </Card>

    {/* Monthly Report Toggle */}
    <Card className="card-premium border-blue-200/50 bg-blue-50/30" data-testid="monthly-report-toggle-card">
      <CardHeader>
        <CardTitle className="text-base font-semibold flex items-center gap-2">
          Relatório Mensal por WhatsApp
          <span className="text-[10px] bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full font-semibold uppercase">Novo</span>
        </CardTitle>
        <CardDescription>
          No dia 1º de cada mês, enviamos um resumo com as 8 métricas do mês anterior direto no seu WhatsApp — ideal para levar à reunião com a equipe. Horário aleatório entre 09h e 17h.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0">
            <p className="text-sm font-medium text-slate-700">Enviar relatório mensal</p>
            <p className="text-xs text-slate-400 mt-0.5">Padrão: ativado. Enviamos para os números do WhatsApp cadastrados acima.</p>
          </div>
          <button
            type="button"
            onClick={() => setSettings(prev => ({ ...prev, monthly_report_enabled: prev.monthly_report_enabled === false ? true : false }))}
            data-testid="monthly-report-toggle"
            className={`relative w-12 h-7 rounded-full transition-colors shrink-0 ${settings.monthly_report_enabled !== false ? 'bg-blue-500' : 'bg-slate-200'}`}
            aria-label="Ativar ou desativar relatório mensal"
          >
            <span className={`absolute top-0.5 w-6 h-6 rounded-full bg-white shadow-sm transition-transform ${settings.monthly_report_enabled !== false ? 'translate-x-5' : 'translate-x-0.5'}`} />
          </button>
        </div>
        {settings.monthly_report_enabled === false && (
          <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg" data-testid="monthly-report-disabled-notice">
            <p className="text-xs text-amber-800">
              ⚠️ Relatório desativado. Você não receberá o resumo mensal no WhatsApp. Você pode continuar gerando manualmente pelo botão &quot;Compartilhar com equipe&quot; em cada indicador do painel.
            </p>
          </div>
        )}
      </CardContent>
    </Card>

    {/* Complaint Tags Feature Flag */}
    <Card className="card-premium border-orange-200/50 bg-orange-50/30" data-testid="complaint-tags-toggle-card">      <CardHeader>
        <CardTitle className="text-base font-semibold flex items-center gap-2">
          Pesquisa Rápida de Motivos
          <span className="text-[10px] bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full font-semibold uppercase">Laboratorio</span>
        </CardTitle>
        <CardDescription>Ativado por padrão. Quando ativado, clientes que derem notas baixas (1 a 3 estrelas) verao opções rápidas por categoria. Desative se preferir não coletar esses dados.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div><p className="text-sm font-medium text-slate-700">Pesquisa rápida de motivos (Notas 1 a 3)</p><p className="text-xs text-slate-400 mt-0.5">Padrão: ativado. O empresario pode desativar a qualquer momento.</p></div>
          <button type="button" onClick={() => setSettings(prev => ({ ...prev, complaint_tags_enabled: !prev.complaint_tags_enabled }))} data-testid="complaint-tags-toggle" className={`relative w-12 h-7 rounded-full transition-colors ${settings.complaint_tags_enabled ? 'bg-orange-500' : 'bg-slate-200'}`}>
            <span className={`absolute top-0.5 w-6 h-6 rounded-full bg-white shadow-sm transition-transform ${settings.complaint_tags_enabled ? 'translate-x-5' : 'translate-x-0.5'}`} />
          </button>
        </div>
        {settings.complaint_tags_enabled && (
          <div className="mt-4 p-3 bg-orange-50 border border-orange-200 rounded-lg space-y-2">
            <p className="text-xs text-orange-700 font-bold">Categorias de tags:</p>
            <p className="text-xs text-orange-700"><strong>Atendimento:</strong> Demora, Falta de Educação, Falta de Atenção, Erro no Pedido, Atendimento Ruim</p>
            <p className="text-xs text-orange-700"><strong>Produto:</strong> Sabor/Tempero, Temperatura, Frescor/Qualidade, Apresentação, Tamanho/Porção</p>
            <p className="text-xs text-orange-700"><strong>Ambiente:</strong> Limpeza/Higiene, Temperatura/Clima, Barulho/Acústica, Iluminação, Conforto/Mobília</p>
          </div>
        )}
      </CardContent>
    </Card>

    {/* Google Maps URL */}
    <Card className="card-premium border-emerald-200/50 bg-emerald-50/30">
      <CardHeader>
        <CardTitle className="text-base font-semibold flex items-center gap-2">
          Link de Avaliação do Google Maps
          <span className="relative group"><HelpCircle className="w-4 h-4 text-slate-400 cursor-help" /><span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 p-2.5 bg-[#0A2647] text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 shadow-lg">Usado para pedir avaliações publicas aos clientes muito satisfeitos.</span></span>
        </CardTitle>
        <CardDescription>Cole o link do seu Google Maps. Clientes com notas altas receberao um e-mail pedindo para avaliar no Google também.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div><Label className="text-sm font-medium mb-1.5 block">Link do Google Maps</Label><Input value={settings.google_maps_url || ''} onChange={(e) => setSettings(prev => ({ ...prev, google_maps_url: e.target.value }))} placeholder="https://g.page/r/seu-negócio/review" className="h-11" data-testid="google-maps-url-input" /></div>
          <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg"><p className="text-xs text-emerald-700 leading-relaxed"><strong>Como encontrar seu link:</strong> Abra o Google Maps, busque sua empresa, clique em "Escrever avaliação" e copie a URL.</p></div>
        </div>
      </CardContent>
    </Card>

    {/* Google Invite Message */}
    <Card className="card-premium border-[#C5A059]/30">
      <CardHeader>
        <CardTitle className="text-base font-semibold leading-snug">Configure aqui a mensagem automática por e-mail para o cliente que avaliou sua empresa com nota alta</CardTitle>
        <p className="text-sm text-[#C5A059] font-medium mt-2">Assim nossa reputação vai subir, pois os elogios vao para o Google e as reclamações teremos a chance de corrigir internamente.</p>
        <CardDescription className="mt-3">Escreva seu agradecimento abaixo. Nos incluiremos o botao para o seu Google automaticamente ao final do e-mail.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <Textarea value={settings.google_invite_message || ''} onChange={(e) => setSettings(prev => ({ ...prev, google_invite_message: e.target.value }))} rows={5} className="resize-none" placeholder={`Muito obrigado por nos avaliar tao bem! Nos da ${company?.name || '[Nome da Empresa]'} trabalhamos diariamente para te servir cada vez melhor. Para nos ajudar a crescer e ser mais reconhecidos em nossa cidade você poderia nos avaliar também no Google? Sua nota faz toda a diferença.`} data-testid="google-invite-message-input" />
          <p className="text-xs text-slate-500 flex items-center gap-1.5"><Star className="w-3.5 h-3.5 text-[#C5A059] flex-shrink-0" />Dica: Um agradecimento sincero incentiva o cliente a te elogiar também no Google!</p>
        </div>
      </CardContent>
    </Card>

    {/* Custom Complaint Tags */}
    <Card className="card-premium">
      <CardHeader>
        <CardTitle className="text-base font-semibold">Detalhamento de Avaliações (Tags)</CardTitle>
        <CardDescription>Personalize as opções que aparecem quando um cliente da nota baixa. Deixe em branco para usar os padroes universais.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-5">
        {[
          { key: 'custom_tags_produto', label: 'Produtos / Serviços', defaults: ['Não Atendeu Expectativa', 'Produto com Defeito', 'Produto em Falta', 'Apresentação Visual', 'Custo-Benefício'] },
          { key: 'custom_tags_atendimento', label: 'Atendimento', defaults: ['Demora no Atendimento', 'Falta de Conhecimento sobre Produto/Serviço', 'Falta de Atenção', 'Erro no Pedido / Serviço', 'Atendimento Grosseiro'] },
          { key: 'custom_tags_ambiente', label: 'Ambiente', defaults: ['Limpeza / Higiene', 'Temperatura / Clima', 'Barulho / Acústica', 'Conforto / Estrutura', 'Organização / Sinalização'] },
        ].map(cat => {
          const currentTags = settings[cat.key] || [];
          const displayTags = currentTags.length > 0 ? currentTags : cat.defaults;
          return (
            <div key={cat.key} className="space-y-2">
              <Label className="text-sm font-semibold text-slate-700">{cat.label}</Label>
              <div className="space-y-1.5">
                {displayTags.map((tag, idx) => (
                  <div key={`${cat.key}-${idx}`} className="flex items-center gap-2">
                    <Input
                      value={tag}
                      onChange={e => {
                        const tags = [...(settings[cat.key]?.length > 0 ? settings[cat.key] : [...cat.defaults])];
                        tags[idx] = e.target.value;
                        setSettings(prev => ({ ...prev, [cat.key]: tags }));
                      }}
                      className="h-8 text-sm flex-1"
                      placeholder={cat.defaults[idx] || 'Tag...'}
                      data-testid={`tag-${cat.key}-${idx}`}
                    />
                    {displayTags.length > 3 && (
                      <button onClick={() => {
                        const tags = [...(settings[cat.key]?.length > 0 ? settings[cat.key] : [...cat.defaults])];
                        tags.splice(idx, 1);
                        setSettings(prev => ({ ...prev, [cat.key]: tags }));
                      }} className="p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded">
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    )}
                  </div>
                ))}
              </div>
              {displayTags.length < 7 && (
                <button onClick={() => {
                  const tags = [...(settings[cat.key]?.length > 0 ? settings[cat.key] : [...cat.defaults]), ''];
                  setSettings(prev => ({ ...prev, [cat.key]: tags }));
                }} className="flex items-center gap-1.5 text-xs text-blue-600 hover:text-blue-800 font-medium">
                  <Plus className="w-3 h-3" />Adicionar tag
                </button>
              )}
            </div>
          );
        })}
        <p className="text-xs text-slate-400">Máximo 7 tags por categoria. Mínimo 3.</p>
      </CardContent>
    </Card>

    {/* Save Button */}
    <div className="flex gap-3">
      <Button onClick={handleSave} disabled={saving} className="btn-primary flex-1 h-11">
        {saving ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Salvando...</> : 'Salvar Alteracoes'}
      </Button>
      <Link to={`/${company?.slug}`} target="_blank">
        <Button variant="outline" className="h-11 gap-2"><Eye className="w-4 h-4" />Ver Pagina</Button>
      </Link>
    </div>
  </div>
);
